import io from 'socket.io-client'
import { createInsideGroupFolderObservers, sharedFileObservers, approveGroupFolderObservers, createGroupFolderObservers, createFileObservers, copyFileObservers, connectionObservers, connectedObservers } from '@/Observers.js'
import vue from 'vue'
import config from '@/services/config'

let socket
function connection () {
  if (typeof socket !== 'undefined') {
    return socket
  }

  let url = process.env.VUE_APP_NODE_ENV === 'development'? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT : process.env.VUE_APP_HTTP + '://' + config.origin

  socket = io(url, { transports: ['websocket'] })
  vue.prototype.$socket = socket
  socket.on('connect', function () {
    connectedObservers.next()
  })

  socket.on('disconnect', function () {
    connectionObservers.next('disconnected')
  })

  socket.on('complete', function (data) {
    copyFileObservers.next(data)
  })

  socket.on('file', function (data) {
    createFileObservers.next(data)
  })

  socket.on('creategroupfolder', function (data) {
    createGroupFolderObservers.next(data)
  })

  socket.on('approvegroupfolder', function (data) {
    approveGroupFolderObservers.next(data)
  })

  socket.on('sharedfile', function (data) {
    sharedFileObservers.next(data)
  })

  socket.on('createinsidegroupfolder', function (data) {
    createInsideGroupFolderObservers.next(data)
  })

  return socket
}

export default connection()
